import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiPython, SiTensorflow, SiKeras, SiOpencv, SiPytorch, SiScikitlearn,
   SiFlask, SiFastapi, SiDocker, SiC, SiCplusplus, SiJavascript,
  SiMysql, SiSqlite, SiMongodb, SiAmazonaws, 
  SiDatabricks, SiMicrosoftazure
} from "react-icons/si";
import { FaBrain, FaProjectDiagram, FaRobot, FaNetworkWired } from "react-icons/fa";

const skills = [
  { icon: <SiPython />, name: "Python" },
  { icon: <FaRobot />, name: "Generative AI" },
  { icon: <FaRobot />, name: "Agentic AI" },
  { icon: <FaNetworkWired />, name: "RAG" },
  { icon: <FaBrain />, name: "Prompt Engineering" },
  { icon: <FaProjectDiagram />, name: "LangChain" },
  { icon: <FaNetworkWired />, name: "LangGraph" },
  { icon: <SiTensorflow />, name: "TensorFlow" },
  { icon: <SiKeras />, name: "Keras" },
  { icon: <SiOpencv />, name: "OpenCV" },
  { icon: <SiPytorch />, name: "PyTorch" },
  { icon: <SiScikitlearn />, name: "Scikit-learn" },
  { icon: <SiFlask />, name: "Flask" },
  { icon: <SiFastapi />, name: "FastAPI" },
  { icon: <SiDocker />, name: "Docker" },
  { icon: <SiPython />, name: "Python" },
  { icon: <SiMysql />, name: "MySQL" },
  { icon: <SiSqlite />, name: "SQLite" },
  { icon: <SiMongodb />, name: "MongoDB" },
  { icon: <SiAmazonaws />, name: "AWS" },
  { icon: <SiMicrosoftazure />, name: "Azure" },
  { icon: <SiDatabricks />, name: "Databricks" },
  { icon: <SiMysql />, name: "MySQL" },
  { icon: <SiSqlite />, name: "SQLite" },
  { icon: <SiMongodb />, name: "MongoDB" },
  { icon: <SiAmazonaws />, name: "AWS" },
  { icon: <SiMicrosoftazure />, name: "Azure" },
  { icon: <SiDatabricks />, name: "Databricks" },
  { icon: <SiJavascript />, name: "JavaScript" }, 
  { icon: <SiCplusplus />, name: "C++" },
  { icon: <SiC />, name: "C" }
];

function Techstack() {
  return (
    <>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        {skills.map((skill, idx) => (
          <Col xs={4} md={2} className="tech-icons" key={idx} style={{ textAlign: "center" }}>
            {skill.icon}
            <div style={{ fontSize: "0.8rem", marginTop: "5px" }}>{skill.name}</div>
          </Col>
        ))}
      </Row>
    </>
  );
}

export default Techstack;
